import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Divider, Stack, Typography } from '@mui/material'
import React from 'react'
import { OverviewData, OverviewStepFormData } from '../../types'
import Address from './Address'
import Storage from './Storage'
import Photovoltaic from './Photovoltaic'
import Images from './Images'
import { makeStyles } from 'tss-react/mui'
import useOverviewValidation from 'src/Libs/installation-statement/hooks/validation/use-overview-validation'
import { Checkbox } from 'src/Libs/inputs/formik'
import { Formik, FormikProps } from 'formik'
import Measurement from 'src/Libs/installation-statement/components/Overview/Measurement'
import Edison from './Edison'

const AGREEMENT_ACCEPTANCE_CHECKBOX_NAME = 'accepted'

const useStyles = makeStyles()(theme => ({
  divider: {
    borderColor: theme.palette.shades.shade03,
  },
}))

interface OverviewProps {
  data: OverviewData
  setFormData: (value: FormikProps<OverviewStepFormData>) => void
}

/**
 * Component for the installation statement wizard overview step
 */
const Overview: React.VFC<OverviewProps> = ({ data, setFormData }) => {
  const { t } = useCustomTranslation()
  const { address, storage, photovoltaic, measurements, images, overview, edison } = data
  const { classes } = useStyles()
  const { validationSchema } = useOverviewValidation()

  return (
    <Formik
      initialValues={overview}
      validationSchema={validationSchema}
      onSubmit={() => {
        /* */
      }}
    >
      {formData => {
        setFormData(formData)

        return (
          <Stack spacing={2} sx={{ width: '100%' }}>
            <Typography variant="h4" sx={{ pb: 2 }}>
              {t('installation-statement.overview.title')}
            </Typography>
            <Address
              companyAddress={address.companyAddress}
              customerAddress={address.customerAddress}
              deviatingAddress={address.deviatingAddress}
              deviatingAddressEnabled={address.deviatingAddressEnabled}
              installer={address.installer}
            />
            <Divider className={classes.divider} />
            <Storage data={storage} />
            {storage.showEdisonWallboxStep ? (
              <>
                <Divider className={classes.divider} />
                <Edison data={edison} />
              </>
            ) : null}
            <Divider className={classes.divider} />
            <Photovoltaic data={photovoltaic} />
            <Divider className={classes.divider} />
            <Measurement data={measurements} />
            <Divider className={classes.divider} />
            <Images data={images} />
            <Divider className={classes.divider} />
            <Checkbox name={AGREEMENT_ACCEPTANCE_CHECKBOX_NAME} label={t('installation-statement.overview.agreement-acceptance')} />
          </Stack>
        )
      }}
    </Formik>
  )
}

export default Overview
